import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { connect } from 'react-redux';
import AquaAudio from 'root/lib/AquaAudio';
import { SEASON } from 'root/activities/hub/data/constants';
import WorkshopLoading from './WorkshopLoading';
import { getIsPlacementTool } from '../../hub/selectors/index';
import GenericSpinner from '../GenericSpinner';
import styles from './styles';

export const ANIMATION_TYPE = {
  SPINNER: 'spinner',
  GLYPH: 'glyph',
};

export const LoadingScreenComponent = ({ className, children, animationType, backgroundColor, noAudioUnload }) => {
  useEffect(() => {
    if (noAudioUnload) return () => {};
    // we wait for any clicking sfx that might be playing to finish
    // before unloading the audio
    const timeout = setTimeout(() => {
      AquaAudio.unload();
    }, 350);
    return () => clearTimeout(timeout);
  }, [noAudioUnload]);

  const renderGlyph = () => (<WorkshopLoading />);

  const renderSpinner = () => (
    <View testID="loadingSpinner" style={[styles.container, { backgroundColor }]}>
      {children}
      <GenericSpinner style={styles.spinnerContainer} />
    </View>
  );

  return (
    <div className={className} data-dd-action-name="loading-screen">
      {animationType === ANIMATION_TYPE.GLYPH ? renderGlyph() : renderSpinner()}
    </div>
  );
};

LoadingScreenComponent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  animationType: PropTypes.string,
  backgroundColor: PropTypes.string,
  noAudioUnload: PropTypes.bool,
};

LoadingScreenComponent.defaultProps = {
  className: '',
  children: null,
  animationType: undefined,
  backgroundColor: 'transparent',
  noAudioUnload: false,
};

const mapStateToProps = (state, ownProps) => {
  const { GLYPH, SPINNER } = ANIMATION_TYPE;
  const isSeason3 = state.questWorkflowReducer.season === SEASON.GRADE_4_5;
  const isPlacementTool = getIsPlacementTool(state);
  let { animationType } = ownProps;
  if (animationType === undefined) {
    if (isPlacementTool) {
      animationType = SPINNER;
    } else {
      animationType = isSeason3 ? GLYPH : SPINNER;
    }
  }
  return ({ animationType });
};

export default connect(mapStateToProps, null)(LoadingScreenComponent);
